const searchStates = {
    INIT: Symbol('Init'),
    UPDATING: Symbol('Updating facets'),
    PAGINATING: Symbol('Moving to next page'),
    SEARCHING: Symbol('Searching for occasions'),
    RESTING: Symbol('Resting')
};

export default searchStates;
